import client from "../apollo/apolloClient";
import API from "../axios";
import ApolloMultimedia from "../apollo/apolloMultimedia";
import CONSTANTS from "../const/constants";
import { useDispatch } from "react-redux";
import { addFileAction, setTempFileAsSelected } from "../redux/multimediaDuck";

export const getAlbums = async (spaces) => {
  const variables = { isRoot: true, spacesIdIn: spaces };
  const { data } = await client.query({
    query: ApolloMultimedia.GET_ALBUMS,
    variables,
  });
  return data.albums;
};

export const createAlbum = async (companyId, spaceId, name, parentId) => {
  const data = { companyId, spaceId, name };
  if (parentId) data.parentId = parentId;
  const response = await API.post("/createAlbum", data);
  return response.data;
};

export const uploadFile = async (formData, onUploadProgress) => {
  try {
    const config = {
      onUploadProgress: (progressEvent) => {
        onUploadProgress(
          Math.round((progressEvent.loaded * 100) / progressEvent.total)
        );
      },
    };
    const response = await API.put("/uploadFile", formData, config);
    return response.data;
  } catch (error) {
    onUploadProgress(0, error);
    throw error;
  }
};

export const getFilesAndSubalbums = async (albumId) => {
  const { data } = await client.query({
    query: ApolloMultimedia.GET_ALBUM_FILES_AND_SUBALBUMS,
    variables: { albumId },
  });
  return data.album;
};

export const deleteFile = async (fileId) => {
  const response = await API.delete("/removeContent", { data: { fileId } });
  return response;
};

export const deleteAlbum = async (albumId) => {
  const response = await API.delete("/deleteAlbum", { data: { albumId } });
  return response;
};

export const getSubAlbumFiles = async (albumId) => {
  const { data } = await client.query({
    query: ApolloMultimedia.GET_SUBALBUM_FILES,
    variables: { albumId },
  });
  return data.album;
};

export const uploadVideo = async (url, albumId) => {
  const response = await API.put("/uploadFile", {
    name: url,
    url,
    albumId,
    fileType: "VIDEO",
  });
  return response.data;
};

export const fileTypes = (constFileType) => {
  const genericTypes = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/pdf",
    "application/x-rar-compressed",
    "text/csv",
    "text/plain",
    "application/zip",
    "application/x-zip-compressed",
    "application/x-compressed",
    "application/x-7z-compressed",
    "application/x-compressed-tar",
    "application/x-compressed-tar-gz",
    "application/x-compressed-tar-bz2",
    "application/x-compressed-tar-xz",
  ];

  const imageTypes = ["image/jpg", "image/png", "image/jpeg"];
  const videoTypes = ["video/mp4", "video/3gpp"];
  const templateTypes = [...imageTypes, "application/pdf", "video/mp4"];

  switch (constFileType) {
    case CONSTANTS.FILE_TYPE_IMAGE:
      return imageTypes.join(",");
    case CONSTANTS.FILE_TYPE_GENERIC:
    case CONSTANTS.FILE_TYPE_PDF:
      return genericTypes.join(",");
    case CONSTANTS.FILE_TYPE_VIDEO:
    case "MP4":
      return videoTypes.join(",");
    case CONSTANTS.FILE_TYPE_TEMPLATE:
      return templateTypes.join(",");
    case "PNG":
    case "JPG":
      return ["image/png", "image/jpeg"].join(",");
    default:
      return [...genericTypes, "application/zip"].join(",");
  }
};

export const onDrop = async (acceptedFiles, dispatch, addFiles) => {
  if (acceptedFiles && acceptedFiles.length > 0) {
    console.log("acceptedFilesOnDrop ===> ", acceptedFiles);
    const files = acceptedFiles.map((file) => {
      if (file?.id) return file;
      return {
        id: CONSTANTS.UPLOAD_ID,
        file,
        url: URL.createObjectURL(file),
        fileType: file.name.split(".").pop() === "mp4" ? "VIDEO" : file.name.split(".").pop(),
        fileName: file.name,
        mimeType: file.type,
        weight: file.size,
      };
    });

   dispatch(setTempFileAsSelected(files));
  }
};
